import { PitchCrop } from '@/types/visualisation';

// Under Against the API mirrors the markers to the viewed team's end, so the zoom moves to the other end with them.
// A full pitch and the centre third have no other end. Typed as a Record so a new crop name must get an entry.
const SWAPPED_PITCH_CROP: Record<PitchCrop, PitchCrop> = {
  FULL_PITCH: 'FULL_PITCH',
  CENTRE_THIRD: 'CENTRE_THIRD',
  HOME_BOX: 'OPPOSITION_BOX',
  OPPOSITION_BOX: 'HOME_BOX',
  HOME_THIRD: 'OPPOSITION_THIRD',
  OPPOSITION_THIRD: 'HOME_THIRD',
  HOME_HALF: 'OPPOSITION_HALF',
  OPPOSITION_HALF: 'HOME_HALF',
};

export const swapPitchCrop = (crop: PitchCrop): PitchCrop => SWAPPED_PITCH_CROP[crop];
